export const berattandeTextRubrics = [
	{
		name: "Berättande text",
		grade: "åk3",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) En tydlig början, mitt och slut 2) En enkel konflikt 3) En lösning på problemet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) En början och ett slut 2) Ett problem som löses",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) En händelse med ett slut 2) Någon form av problem",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig handling 2) Problem eller konflikt",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Beskrivning av hur personer ser ut 2) Beskrivning av platsen 3) Enkla känslor hos personerna",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Några detaljer om personer 2) Nämner var det händer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nämner personer 2) Nämner plats",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Personer 2) Plats",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Enkel dialog med talstreck 2) Några beskrivande ord 3) Berättar i rätt ordning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Någon dialog 2) Beskrivande ord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Personer som pratar 2) Enkla ord",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Beskrivningar",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Stor bokstav och punkt 2) Stavar vanliga ord rätt 3) Några olika meningar",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Oftast stor bokstav och punkt 2) Stavar några ord rätt",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Ibland stor bokstav och punkt 2) Går att läsa",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Stor bokstav och punkt 2) Läsbarhet",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "åk4",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Tydlig röd tråd 2) Problem och lösning 3) Spännande vändning 4) Bra avslutning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Handling som hänger ihop 2) Problem som löses 3) Ett slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel handling 2) Ett problem 3) Slutar berättelsen",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sammanhängande handling 2) Problem 3) Tydligt slut",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Beskriver personer tydligt 2) Beskriver miljön 3) Visar känslor",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Beskriver personer 2) Nämner miljön 3) Några känslor",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nämner hur någon är 2) Var det händer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Beskrivningar 2) Miljö",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Bra dialog med talstreck 2) Beskrivande ord 3) Rätt ordning i berättandet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Dialog med talstreck 2) Några beskrivande ord",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Någon dialog 2) Enkla beskrivningar",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Beskrivningar",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Korrekt meningsbyggnad 2) Styckeindelning 3) Stavar rätt",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Oftast rätt meningar 2) Försöker dela i stycken",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Begripliga meningar 2) Få stavfel",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Meningsbyggnad 2) Stavning",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "åk5",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genomtänkt handling 2) Tydlig konflikt 3) Spännande vändpunkter 4) Bra upplösning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad handling 2) Problem och lösning 3) Någon vändpunkt",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel handling 2) Ett problem 3) En lösning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Handling 2) Problem 3) Lösning",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Levande personer 2) Detaljrik miljö 3) Tydliga känslor 4) Personlig stil",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Beskrivna personer 2) Beskriven miljö 3) Några känslor",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla personer 2) Enkel miljö 3) Känslor nämns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Personer 2) Miljö 3) Känslor",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierad dialog 2) Målande språk 3) Röd tråd 4) Olika tempus",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Beskrivande språk 3) Sammanhang",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel dialog 2) Enkelt språk 3) Viss struktur",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Beskrivningar 3) Struktur",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierande meningar 2) Tydliga stycken 3) Få språkfel 4) Personligt språk",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Bra meningar 2) Styckeindelning 3) Mestadels rätt stavning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla meningar 2) Försök till stycken 3) Grundläggande stavning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Meningsbyggnad 2) Stycken 3) Stavning",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "åk6",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex handling 2) Flera konflikter 3) Effektiva vändpunkter 4) Övertygande upplösning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad handling 2) Tydlig konflikt 3) Vändpunkt 4) Bra slut",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel handling 2) Ett problem 3) En lösning",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Handling 2) Konflikt 3) Lösning",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Nyanserade personer 2) Detaljerade miljöer 3) Djupa känslor 4) Trovärdiga relationer",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade personer 2) Beskrivande miljöer 3) Tydliga känslor",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla personer 2) Enkel miljö 3) Några känslor",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Personer 2) Miljö 3) Känslor",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Utvecklad dialog 2) Rikt bildspråk 3) Olika perspektiv 4) Medveten tempusanvändning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Beskrivande språk 3) Ett perspektiv",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel dialog 2) Enkelt språk 3) Berättarperspektiv",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Beskrivningar 3) Perspektiv",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierat språk 2) Genomtänkta stycken 3) Korrekt språk 4) Stilistiska verktyg",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklat språk 2) Tydliga stycken 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt språk 2) Styckeindelning 3) Grundläggande korrekthet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språkhantering 2) Stycken 3) Korrekthet",
					},
				],
			},
		],
	},

	{
		name: "Berättande text",
		grade: "åk7",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex handling med parallella spår 2) Flera övertygande konflikter 3) Kreativa vändpunkter 4) Genomtänkt upplösning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad handling 2) Tydliga konflikter 3) Vändpunkter 4) Bra upplösning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel handling 2) En konflikt 3) En vändpunkt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig handling 2) Konflikt 3) Vändpunkt",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Fördjupade personporträtt 2) Levande miljöskildringar 3) Psykologiskt djup 4) Komplexa relationer",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade personer 2) Detaljerade miljöer 3) Tydliga relationer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla personer 2) Grundläggande miljö 3) Några relationer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Personbeskrivningar 2) Miljöbeskrivningar 3) Relationer",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierad och effektiv dialog 2) Avancerat bildspråk 3) Medvetet perspektivval 4) Skicklig tempushantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad dialog 2) Tydligt bildspråk 3) Genomtänkt perspektiv",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Enkelt bildspråk 3) Ett perspektiv",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Bildspråk 3) Perspektiv",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Precist och varierat språk 2) Effektfull styckeindelning 3) Stilistisk säkerhet 4) Språklig korrekthet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklat språk 2) Logisk styckeindelning 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Styckeindelning 3) Viss korrekthet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fungerande språk 2) Stycken 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "åk8",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sofistikerad handling med flera spår 2) Djupa konflikter 3) Innovativa vändpunkter 4) Skicklig upplösning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välutvecklad handling 2) Övertygande konflikter 3) Effektiva vändpunkter",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydlig handling 2) En konflikt 3) Vändpunkt finns",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sammanhängande handling 2) Konflikt 3) Vändpunkt",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Dynamiska karaktärer 2) Symboliska miljöer 3) Djup persongestaltning 4) Nyanserade relationer",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade karaktärer 2) Genomarbetade miljöer 3) Trovärdiga relationer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Grundläggande karaktärer 2) Beskrivna miljöer 3) Några relationer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Karaktärsutveckling 2) Miljöbeskrivning 3) Relationer",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Avancerad dialog 2) Originellt bildspråk 3) Konstnärliga grepp 4) Medveten tempusväxling",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välutvecklad dialog 2) Effektivt bildspråk 3) Genomtänkta grepp",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Tydligt bildspråk 3) Några berättargrepp",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Fungerande dialog 2) Bildspråk 3) Berättargrepp",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Träffsäkert och personligt språk 2) Medveten styckeindelning 3) Avancerade stilgrepp 4) Språklig precision",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välutvecklat språk 2) Effektiv styckeindelning 3) Stilistisk medvetenhet",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydligt språk 2) Fungerande stycken 3) Grundläggande stil",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Styckeindelning 3) Stil",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "åk9",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex och genomtänkt handling 2) Tydlig dramaturgisk kurva 3) Kreativa vändpunkter 4) Skickligt uppbyggd spänning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad handling 2) Fungerande dramaturgi 3) Tydliga vändpunkter 4) God spänning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel handling 2) Viss dramaturgi 3) Någon vändpunkt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydlig handling 2) Dramaturgi 3) Vändpunkter",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Levande och detaljrika miljöer 2) Mångsidiga karaktärer 3) Trovärdiga relationer 4) Skicklig gestaltning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade miljöer 2) Tydliga karaktärer 3) Fungerande relationer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkla miljöer 2) Grundläggande karaktärer 3) Vissa relationer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Miljöbeskrivningar 2) Karaktärsutveckling 3) Relationer",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Effektiv dialog 2) Varierat bildspråk 3) Skicklig perspektivhantering 4) Genomtänkt tempus",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Tydligt bildspråk 3) Konsekvent perspektiv",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkel dialog 2) Visst bildspråk 3) Grundläggande berättarperspektiv",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Bildspråk 3) Tydligt perspektiv",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Varierat och träffsäkert språk 2) Effektfulla stilgrepp 3) Målande beskrivningar 4) Fullt korrekt språkhantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklat språk 2) Fungerande stilgrepp 3) Få språkfel",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Enkelt men fungerande språk 2) Vissa stilgrepp 3) Mestadels korrekt",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Tydligt språk 2) Stilgrepp 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "firstRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Komplex flerskiktad handling 2) Psykologiska konflikter 3) Subtila vändpunkter 4) Konstnärlig helhet 5) Tematisk djup",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Välutvecklad handling 2) Trovärdiga konflikter 3) Genomtänkta vändpunkter 4) Tematisk medvetenhet",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydlig handling 2) Konflikter finns 3) Några vändpunkter",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklad handling 2) Konflikter 3) Vändpunkter",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Djuppsykologiska porträtt 2) Atmosfäriska miljöer 3) Symboliska element 4) Komplexa relationer 5) Subtil persongestaltning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklade personporträtt 2) Betydelsebärande miljöer 3) Nyanserade relationer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Beskrivna personer 2) Fungerande miljöer 3) Grundläggande relationer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Persongestaltning 2) Miljöskildringar 3) Relationer",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Sofistikerad dialog 2) Mångtydigt bildspråk 3) Innovativa berättargrepp 4) Medveten perspektivteknik 5) Avancerad temporalitet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Nyanserad dialog 2) Utvecklat bildspråk 3) Effektiva berättargrepp 4) Genomtänkt perspektiv",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Grundläggande bildspråk 3) Några berättargrepp",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Bildspråk 3) Berättarteknik",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Konstfärdigt språk 2) Retoriska effekter 3) Stilistisk originalitet 4) Komplex meningsbyggnad 5) Perfekt språkhantering",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Genomarbetat språk 2) Stilistisk säkerhet 3) Varierad meningsbyggnad 4) God språkhantering",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Viss stilistik 3) Grundläggande korrekthet",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språklig variation 2) Stil 3) Korrekthet",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "secondRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Virtuos narrativ struktur 2) Existentiella konflikter 3) Innovativ dramaturgi 4) Tematisk komplexitet 5) Konstnärlig vision",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Komplex handling 2) Djupa konflikter 3) Effektiv dramaturgi 4) Tematisk klarhet",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklad handling 2) Tydliga konflikter 3) Grundläggande dramaturgi",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Sammanhållen handling 2) Konflikter 3) Dramaturgi",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mångbottnade karaktärer 2) Symboliskt laddade miljöer 3) Psykologiskt djup 4) Relationell komplexitet 5) Litterär gestaltning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Fördjupade karaktärer 2) Meningsbärande miljöer 3) Utvecklade relationer 4) God gestaltning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Tydliga karaktärer 2) Beskrivande miljöer 3) Grundläggande relationer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Karaktärsutveckling 2) Miljöskildring 3) Relationer",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Mästerlig dialogteknik 2) Nyskapande bildspråk 3) Avancerade berättargrepp 4) Komplex fokalisering 5) Virtuos temporalitet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklad dialog 2) Träffsäkert bildspråk 3) Genomtänkta berättargrepp 4) Medveten fokalisering",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande dialog 2) Tydligt bildspråk 3) Några berättargrepp",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Bildspråk 3) Berättarteknik",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Litterärt språk 2) Stilistisk briljans 3) Retorisk mästerskap 4) Syntaktisk variation 5) Total språkbehärskning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Nyanserat språk 2) Stilistisk säkerhet 3) Retorisk medvetenhet 4) God syntax",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Fungerande språk 2) Viss stilistik 3) Grundläggande retorik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språklig variation 2) Stil 3) Retorik",
					},
				],
			},
		],
	},
	{
		name: "Berättande text",
		grade: "thirdRing",
		custom: true,
		userId: "Z6BLSMsm38Un5mgW0O6Z3TToHq12",
		createdAt: new Date("2025-02-24T10:15:30.000Z"),
		criteria: [
			{
				name: "Handling och dramaturgi",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Genreöverskridande handling 2) Filosofiska konfliktnivåer 3) Experimentell dramaturgi 4) Tematisk originalitet 5) Konstnärligt nyskapande",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Avancerad handling 2) Flerskiktade konflikter 3) Säker dramaturgi 4) Tematisk fördjupning",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Komplex handling 2) Utvecklade konflikter 3) Fungerande dramaturgi",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Utvecklad handling 2) Konflikter 3) Dramaturgi",
					},
				],
			},
			{
				name: "Miljö- och personbeskrivning",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Arketypiska karaktärer 2) Allegoriska miljöer 3) Existentiellt djup 4) Systemisk relationskomplexitet 5) Konstnärlig gestaltning",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Komplexa karaktärer 2) Symboliska miljöer 3) Psykologiskt djup 4) Utvecklade relationer",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklade karaktärer 2) Betydelsebärande miljöer 3) Tydliga relationer",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Karaktärsdjup 2) Miljösymbolik 3) Relationer",
					},
				],
			},
			{
				name: "Berättartekniska verktyg",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Experimentell dialog 2) Nydanande bildspråk 3) Genreöverskridande grepp 4) Komplex berättarteknik 5) Innovativ temporalitet",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Avancerad dialog 2) Personligt bildspråk 3) Säkra berättargrepp 4) Utvecklad teknik",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Utvecklad dialog 2) Fungerande bildspråk 3) Tydliga berättargrepp",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Dialog 2) Bildspråk 3) Berättarteknik",
					},
				],
			},
			{
				name: "Språk och stil",
				descriptors: [
					{
						grade: "A",
						text: "MÅSTE HA: 1) Nyskapande språk 2) Stilistisk innovation 3) Retorisk virtuositet 4) Komplex syntax 5) Konstnärlig språkbehandling",
					},
					{
						grade: "C",
						text: "MÅSTE HA: 1) Utvecklat språk 2) Personlig stil 3) Retorisk säkerhet 4) Avancerad syntax",
					},
					{
						grade: "E",
						text: "MÅSTE HA: 1) Nyanserat språk 2) Tydlig stil 3) Grundläggande retorik",
					},
					{
						grade: "F",
						text: "SAKNAR: 1) Språklig utveckling 2) Stil 3) Retorik",
					},
				],
			},
		],
	},
];
